import { useState, type FormEvent } from 'react'
import { formatWallClock, localDayKey, type AttendanceReportStamp } from '@wf/shared'
import { ApiError } from '../api/client'
import { STAMP_KIND_LABEL } from '../corrections/labels'
import { formatDateDE } from '../time/format'
import { useCorrectAttendance } from './useZeiten'

/**
 * Stempel entwerten (W9.1): Inline-Panel mit Pflicht-Grund. Das Original wird NIE gelöscht — es bleibt
 * durchgestrichen im Nachweis (append-only, GoBD/Arbeitszeit-Nachweis). 409 = bereits entwertet.
 */
export function VoidStampPanel({ stamp, onDone, onClose }: { stamp: AttendanceReportStamp; onDone: () => void; onClose: () => void }) {
  const [reason, setReason] = useState('')
  const [localError, setLocalError] = useState<string | null>(null)
  const correct = useCorrectAttendance()

  function submit(event: FormEvent) {
    event.preventDefault()
    if (!reason.trim()) {
      setLocalError('Bitte einen Grund angeben (bleibt dauerhaft dokumentiert)')
      return
    }
    setLocalError(null)
    correct.mutate({ action: 'void', stampId: stamp.id, reason: reason.trim() }, { onSuccess: onDone })
  }

  const serverError = correct.error instanceof ApiError ? correct.error.message : correct.error ? 'Entwerten fehlgeschlagen.' : null

  return (
    <form className="wf-card" onSubmit={submit} aria-label="Stempel entwerten">
      <h3 className="wf-sectionhead">Stempel entwerten</h3>
      <p className="hint">
        Betroffen: {STAMP_KIND_LABEL[stamp.kind]} · {formatDateDE(localDayKey(stamp.tsMs))} {formatWallClock(stamp.tsMs)} Uhr. Das
        Original bleibt durchgestrichen sichtbar — Korrekturen sind dauerhaft nachvollziehbar.
      </p>
      <label className="wf-field">
        <span className="wf-label">Grund (Pflicht)</span>
        <input
          className="wf-input"
          type="text"
          placeholder="z. B. versehentlich doppelt gestempelt"
          maxLength={300}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
      </label>
      {localError ? (
        <p className="error" role="alert">
          {localError}
        </p>
      ) : null}
      {serverError ? (
        <p className="error" role="alert">
          {serverError}
        </p>
      ) : null}
      <div className="wf-listfoot">
        <button type="button" className="wf-btn wf-btn--ghost" onClick={onClose}>
          Abbrechen
        </button>
        <button type="submit" className="wf-btn wf-btn--danger" disabled={correct.isPending}>
          {correct.isPending ? 'Entwerte…' : 'Entwerten'}
        </button>
      </div>
    </form>
  )
}
